import e from "./_isPrototype.js";
import a from "./_nativeKeys.js";
var s = e, i = a, n = Object.prototype, p = n.hasOwnProperty;
function v(r) {
  if (!s(r))
    return i(r);
  var o = [];
  for (var t in Object(r))
    p.call(r, t) && t != "constructor" && o.push(t);
  return o;
}
var y = v;
export {
  y as default
};
//# sourceMappingURL=_baseKeys.js.map
